<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-02-28 17:37:47
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-09-03 16:58:25
 * @Description: file content
 -->
<template>
  <div class="t7_photo">
    <div class="around">
      <div
        class="around_item"
        :class="{active:item.type == selectedAroundType,hide: item.type == 4 && hideVideoVr, hide: item.type == 3 && hideFloorPlan}"
        @click="clickAroundType(item)"
        v-for="item in aroundList"
      >{{item.name}}</div>
    </div>
    <div class="line"></div>
    <div
      class="layer1"
      v-if="photoList&&photoList.length>0&&(selectedAroundType==1||selectedAroundType==2||selectedAroundType==3)"
      v-viewer
    >
      <div class="item" v-for="item in photoList">
        <img :src="item.img" :key="item.img" :alt="item.name" />
      </div>
    </div>
    <div class="layer2" v-else-if="photoList&&photoList.length>0&&selectedAroundType==4">
      <div class="item" v-for="item in photoList">
        <video-player
          v-if="item.type==1"
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="item.playerOptions"
          @play="onPlayerPlay($event)"
        ></video-player>
        <img v-if="item.type==2" :src="item.img" @click="clickVr(item)" alt />
      </div>
    </div>
    <div class="layer3" v-else>敬请期待</div>
    <!-- lj50 -->
    <BtnBackLayout4></BtnBackLayout4>
  </div>
</template>

<script>
import util from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
const BtnBackLayout4 = () => import("@/components/btn_back_layout4");
import Vue from "vue";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
Vue.use(Viewer);
Viewer.setDefaults({
  title: function (item) {
    if (item.alt.startsWith("####")) {
      return item.alt.replace("####", "");
    }
    return "";
  },
  toolbar: {
    zoomIn: false,
    zoomOut: false,
    oneToOne: false,
    reset: false,
    prev: true,
    play: false,
    next: true,
    rotateLeft: false,
    rotateRight: false,
    flipHorizontal: false,
    flipVertical: false,
  },
});
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";

export default {
  components: {
    videoPlayer,
    BtnBackLayout4,
  },
  props: {},
  data() {
    return {
      hideVideoVr: false,
      hideFloorPlan: false,
      aroundList: [
        {
          name: "周边配套",
          type: 2,
        },
        {
          name: "项目内景",
          type: 1,
        },
        {
          name: "户型图",
          type: 3,
        },
        {
          name: "视频VR",
          type: 4,
        },
      ],
      selectedAroundType: 0,
      photoList: [],
      images: [],
      playerList: [],
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "userInfo",
      "rsCardInfo",
    ]),
  },
  methods: {
    clickBack() {
      let tmpObj = {
        id: this.$route.query.id,
        psn: this.$route.query.psn,
        entry: "zxslzx",
      };
      if (this.$route.query.refereeopenid) {
        tmpObj.refereeopenid = this.$route.query.refereeopenid;
      }
      if (this.$route.query.rscuid) {
        tmpObj.rscuid = this.$route.query.rscuid;
      }
      if (this.$route.query.t9id) {
        tmpObj.t9id = this.$route.query.t9id;
      }
      if (this.$route.query.t9psn) {
        tmpObj.t9psn = this.$route.query.t9psn;
      }
      this.$router.push({
        name: "t7",
        params: {},
        query: tmpObj,
      });
    },
    onPlayerPlay(player) {
      this.playerList.push(player);
      console.log("开始播放", player);
      console.log("this.playerList", this.playerList);
      this.playerList.forEach((item) => {
        if (item != player) {
          item.pause();
        }
      });
      // setTimeout(() => {
      //   player.pause();
      // }, 2000);
    },
    clickAroundType(item) {
      this.selectedAroundType = item.type;
      this.getPhoto();
    },
    // lj59
    clickVr(item) {
      util.openUrl(item.videosrc);
    },
    getPhoto() {
      this.photoList = [];
      if (
        this.pageInfo.Extinfo &&
        this.selectedAroundType == 1 &&
        this.pageInfo.Extinfo.samplePlate
      ) {
        this.photoList = this.pageInfo.Extinfo.samplePlate.map((item) => {
          let newItem = {
            img: item.main_img,
            name: "",
          };
          return newItem;
        });
      } else if (
        this.pageInfo.Extinfo &&
        this.selectedAroundType == 2 &&
        this.pageInfo.Extinfo.envImages
      ) {
        this.photoList = this.pageInfo.Extinfo.envImages.map((item) => {
          let newItem = {
            img: item.main_img,
            name: "",
          };
          return newItem;
        });
      } else if (
        this.pageInfo.Extinfo &&
        this.selectedAroundType == 3 &&
        this.pageInfo.Extinfo.floorPlan
      ) {
        this.photoList = this.pageInfo.Extinfo.floorPlan.map((item) => {
          let newItem = {
            img: item.main_img,
            name: "####" + item.name,
          };
          return newItem;
        });
      } else if (
        this.pageInfo.Extinfo &&
        this.selectedAroundType == 4 &&
        this.pageInfo.Extinfo.video
      ) {
        let tmpList = [];
        tmpList = this.pageInfo.Extinfo.video.map((item) => {
          let newItem = {
            img: item.main_img,
            videosrc: item.videosrc,
            type: item.videosrc.indexOf("assets.") > -1 ? 1 : 2, //1 视频 2外链
            playerOptions: {
              playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
              autoplay: false, //如果true,浏览器准备好时开始回放。
              muted: false, // 默认情况下将会消除任何音频。
              loop: false, // 导致视频一结束就重新开始。
              preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
              language: "zh-CN",
              aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
              fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
              sources: [
                {
                  src: item.videosrc, // 路径
                  type: "video/mp4", // 类型
                },
              ],
              poster: item.main_img, //你的封面地址
              // width: document.documentElement.clientWidth,
              notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
              controlBar: {
                timeDivider: true,
                durationDisplay: true,
                remainingTimeDisplay: false,
                fullscreenToggle: true, //全屏按钮
              },
            },
          };
          return newItem;
        });
        if (this.isInMiniProgram) {
          // 不能展示非业务域名的外链
          tmpList = tmpList.filter((item) => {
            if (item.type == 1) {
              return true;
            } else if (item.type == 2) {
              if (
                this.global.MP_DOMAIN.BUSINESS_OTHER[this.global.SUBDOMAIN] &&
                this.global.MP_DOMAIN.BUSINESS_OTHER[
                  this.global.SUBDOMAIN
                ].includes(util.getHostFromUrl(item.videosrc))
              ) {
                return true;
              }
              return false;
            }
          });
        }
        this.photoList = tmpList;
      } else {
        this.photoList = [];
      }
      // for (let index = 0; index < 3; index++) {
      //   this.photoList = this.photoList.concat(this.photoList);
      // }
      this.images = this.photoList.map((item) => {
        return item.img;
      });
      document.scrollingElement.scrollTop = 0;
    },
  },
  created() {
    util.checkMapStateCallback(this, ["pageInfo"]).then(() => {
      if (this.$route.query.type) {
        this.selectedAroundType = this.$route.query.type;
      } else {
        this.selectedAroundType = 1;
      }
      if (util.checkIsHuafa() && this.isInMiniProgram) {
        //华发小程序不展示视频VR
        this.hideVideoVr = true;
      }
      // if (util.checkIsHuafa()) {
      //   //华发不展示户型
      //   this.hideFloorPlan = true
      // }
      this.getPhoto();
    });
  },
  mounted() {
    if (util.checkIsShlfsj()) {
      this.aroundList = [
        {
          name: "周边配套",
          type: 2,
        },
        {
          name: "校区实景",
          type: 1,
        },
        {
          name: "作品鉴赏",
          type: 3,
        },
        {
          name: "视频VR",
          type: 4,
        },
      ];
    }
  },
};
</script>
<style >
.viewer-toolbar {
  transform: scale(1.5);
}

.video-js .vjs-big-play-button {
  top: 38%;
  left: 38%;
}
</style>
<style lang="css" scoped>
.around {
  position: fixed;
  width: 100%;
  height: 1rem;
  font-size: 0;
  background-color: #fff;
  border-bottom: 1px solid #f4f4f4;
  z-index: 10;
}

.around_item {
  display: inline-block;
  width: 25%;
  overflow: hidden;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-size: 0.3rem;
  color: #333;
}

.around_item.active {
  color: #007da6;
  border-radius: 5px;
}
.around_item.hide {
  display: none;
}
.layer1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: stretch;
  padding-top: 1rem;
}

.layer1 .item {
  position: relative;
  width: 30%;
  padding-bottom: 30%;
  margin-left: 2.5%;
  margin-top: 0.2rem;
  height: 0;
}
.layer1 .item > img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.layer2 {
  padding-top: 1rem;
}
.layer2 .item {
  margin: 0.15rem auto;
  width: 94%;
}
.layer2 .item > img {
  width: 100%;
}
.layer3 {
  padding-top: 3rem;
  text-align: center;
}
</style>